import React from "react";

const StatusBadge = ({ status }) => {
  if (status === "1") {
    return (
      <span className="px-4 py-2 bg-green-100 text-green-600 rounded-md font-semibold">
        Payroll Processed
      </span>
    );
  }
  if (status === "2") {
    return (
      <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
        Payroll Under Process
      </span>
    );
  }
  if (status === "3") {
    return (
      <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
        Payroll Pending
      </span>
    );
  }
  if (status === "4") {
    return (
      <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
        Draft in process
      </span>
    );
  }
  if (status === "5") {
    return (
      <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
        Viewing In Draft Mode
      </span>
    );
  }
  return (
    <span className="px-4 py-2 bg-blue-100 text-blue-600 rounded-md font-semibold">
      Viewing In Draft Mode
    </span>
  );
};

export default StatusBadge;
